module.exports = __webpack_public_path__ + "img/check.a6f84103.png";